import curryN from 'lodash/fp/curryN';
import useMutation from './useMutation';

const mutationFactory = curryN(3, (config = {}, apiCall, queryConfig) =>
  useMutation(apiCall, { displayBulkErrors: true, ...config, ...queryConfig }),
);

export default mutationFactory;
